import { LuneTheme, Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC } from 'react'

import AnimatedTitle from '@/components/AnimatedTransactions/AnimatedTitle'
import ColoredChip from '@/components/AnimatedTransactions/ColoredChip'
import useDevice from '@/hooks/useDevice'

const { palette } = LuneTheme

const BookingTile: FC = () => {
    const { smScreen } = useDevice()

    const greyText = {
        fontSize: '10px',
        color: palette.Grey600,
        lineHeight: '14px',
        mb: 1 / 2,
    }

    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <AnimatedTitle title={'Calculate using accessible data'} withDelay />
            <Box
                sx={{
                    filter: 'drop-shadow(0px 32px 72px rgba(4, 131, 9, 0.20))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    maxWidth: '576px',
                    width: '100%',
                    background: 'white',
                    borderRadius: '24px',
                    gap: 3,
                    padding: {
                        xs: '8px 13px',
                        md: '16px 24px',
                    },
                    margin: 'auto',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 3,
                    }}
                >
                    {smScreen ? (
                        <Image
                            width={22}
                            height={22}
                            src={'/icons/icon-booking.png'}
                            alt={'booking-icon'}
                        />
                    ) : (
                        <Image
                            width={40}
                            height={40}
                            src={'/icons/icon-booking.png'}
                            alt={'booking-icon'}
                        />
                    )}
                    <Box>
                        <Text sx={greyText}>Merchant</Text>
                        <Text variant={'body2'}>booking.com</Text>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 3,
                    }}
                >
                    <Box>
                        <Text sx={greyText}>Amount</Text>
                        <Text variant={'body2'}>$ 754.36</Text>
                    </Box>
                    <Box>
                        <Text sx={greyText}>Emissions</Text>
                        <ColoredChip version={'dark-green'} loadingEffect>
                            573 kgCO₂e
                        </ColoredChip>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default BookingTile
